var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"title-box"},[_c('span',{staticClass:"curr"},[_vm._v("组织机构")])]),_c('img',{staticClass:"head-img",attrs:{"src":require("@/assets/img/icon_zuzhi_img.png"),"alt":""}})])
}]

export { render, staticRenderFns }